import type { ConnectWalletModalProps } from '@rango-dev/internal-profile/components';

import { ConnectWalletModal } from '@rango-dev/internal-profile/components';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { useAppSelector } from '../../hooks/reduxHooks';
import { useWindowDimensions } from '../../hooks/useWindowDimensions';
import { sortedBlockchainSelector } from '../../state/MetaSlice';
import { Dialog } from '../Dialog';
import { ModalHeader } from '../ModalHeader';
import { SimpleNotification } from '../SimpleNotification';

type PropTypes = Pick<
  ConnectWalletModalProps,
  | 'indexInStack'
  | 'afterConnect'
  | 'onDetachedConfirm'
  | 'detachedConfirmText'
  | 'shouldExcludeWallet'
  | 'forceConnectToNamespaces'
> & { title?: string };

export default function ConnectWalletModalWrapper(props: PropTypes) {
  const isDarkMode = useAppSelector((state) => state.settings.isDarkMode);
  const allBlockchains = useAppSelector(sortedBlockchainSelector);
  const { isMobile } = useWindowDimensions();
  const { t } = useTranslation();
  return (
    <ConnectWalletModal
      {...props}
      isMobile={isMobile}
      isDarkMode={isDarkMode}
      allBlockchains={allBlockchains}
      renderHeader={(headerProps) => (
        <ModalHeader
          showBackButton={headerProps.showBackButton}
          title={headerProps.title || props.title || t('Connect Wallet')}
          onClose={() => headerProps.handleClose()}
        />
      )}
      renderModal={(modalProps) => (
        <Dialog
          open={modalProps.open}
          onOpenChange={(open) => {
            if (!open) {
              modalProps.onClose();
            }
          }}
          title={modalProps.title}
          footer={modalProps.footer}
          width="small">
          {modalProps.children}
        </Dialog>
      )}
      renderNotification={(notificationProps) => (
        <SimpleNotification
          key={notificationProps.message.message}
          message={notificationProps.message.message}
          open={notificationProps.message.open}
          setOpen={() => notificationProps.setOpen()}
          severity="error"
          autoHideDuration={notificationProps.autoHideDuration}
        />
      )}
    />
  );
}
